module.exports = __webpack_public_path__ + "cc2e5167a4d448817eb9111a72df84b7.png";